export default "__VITE_ASSET__WTAb6KH3__"